export const isInEventMode =
  new URLSearchParams(window.location.search).get('event') != null

export const eventSlug = new URLSearchParams(window.location.search).get(
  'event',
)
